/**
 * If true, the user agent already supports the 'maxTouchPoints' property on the Navigator prototype
 * @type {boolean}
 */
export const SUPPORTS_MAX_TOUCH_POINTS = "maxTouchPoints" in Navigator.prototype;
